module.exports = __webpack_public_path__ + "img/6_33.7335837b.png";